import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {BaseService} from './BaseService';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import 'rxjs/add/operator/map';


@Injectable()

export class ExporterService {
    updatedata: any

    constructor(private http: HttpClient, private baseurl: BaseService, private spinnerService: Ng4LoadingSpinnerService) {}

//    updateCmpy(UserVO, user, contacts, exporter, address, attachment, pan, portcodes,companytype, salesContactId, userByLastupdatedbyStr,expRegNo) {
//        let date = new Date()
//
//        let url: string = '/updateexportercompany';
//        let body = JSON.stringify({
//            id: user.companyid,
//            companyName: user.companyVO.companyName,
//            iec: user.companyVO.iec,
//            pan: pan,
//            portCodes: portcodes,
//            companytype: companytype,
//            salesContactId: salesContactId,
//            lastUpdatedDate: date,
//            userByLastupdatedbyStr: userByLastupdatedbyStr,
//            userVOs: UserVO,
//            stuffingType: user.companyVO.stuffingType,
//            expRegNo: expRegNo,
//            kycVOs: [
//                {
//                    incorparateDate: exporter.incorparateDate,
//                    pan: exporter.pan,
//                    status: exporter.status,
//                }],
//            postalAddressesVOs: address,
//            contactVOs: contacts,
//            attachmentVOs: attachment
//
//        });
//
//        console.log(body);
//        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
//        this.spinnerService.show()
//        return this.http.put(this.baseurl.url + url + '/' + user.companyid, body, {headers}).map((res) => {
//            res;
//            this.spinnerService.hide()
//            this.updatedata = res;
//            return this.updatedata;
//        }).catch(
//            (error: Response) => {
//                this.spinnerService.hide()
//                return Observable.throw(error);
//            });
//
//
//
//    }
    
     updateCmpy(data) {
        let date = new Date()

        let url: string = '/updateexportercompany';
        let body = JSON.stringify(data);
        console.log(body);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.put(this.baseurl.url + url + '/' + data.id, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
//            this.updatedata = res;
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });



    }

    findexporterbyid(user) {
        console.log("@@@@@@@@", user)
        let url: string = '/findexportercompanyid';
        let body = JSON.stringify({id: user.companyid});
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }

    search_exporter(exporter) {
        let url: string = '/searchexportercompany';
        let body = JSON.stringify({id: exporter.id, companyName: exporter.companyName, pan: exporter.pan, iec: exporter.iec, status: exporter.status, salesContactId: exporter.salesContactId, stuffingType: exporter.stuffingType, isDri: exporter.isDri})
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    states() {
        let url: string = '/getallstate';
        return this.http.get(this.baseurl.url + url).map((res) => {res; return res;})
    }

    country() {
        let url: string = '/getallcountry';
        return this.http.get(this.baseurl.url + url).map((res) => {res; return res;})
    }

    findUserByName(user) {
        let url: string = '/findUserByName';

        let body = JSON.stringify({username: user})
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }

    getAllUsers() {
        let url: string = '/getAllUsers';
        return this.http.get(this.baseurl.url + url).map((res) => {
            res;
            return res;
        }).catch(
            (error: Response) => {
                return Observable.throw(error);
            });
    }

    updateFileattachment(attach: any) {
        let url = '/updateFileattachment';
        let body = JSON.stringify(attach);
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.put(this.baseurl.url + url + '/' + attach.id, body, {headers}).map((res) => {

            res;
            console.log("res12", JSON.stringify(res));
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
     findaddress(id: number) {
        let url: string = "/searchpostaladdress";
        let body = JSON.stringify({
            exportCompanyid: id
        });
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {res; return res});
    }
    
     updateIECChange(data: any) {
        let url = '/updateIECChange';
        let body = JSON.stringify(data);
        console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url , body, {headers}).map((res) => {
            res;
            console.log("res12", JSON.stringify(res));
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    
    deleteAttachment(data:any) {
        let url: string = '/deleteFileAttchement';
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        let body = JSON.stringify(data);
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });

    }
    
    searchUserByCriteria(data) {
        let url: string = '/searchUserByCriteria';
        let body = JSON.stringify(data);
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;
        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/service/ExporterService.ts